import httpClient from "@utils/httpClient";

/**
 * Per-user email notification preferences. Each flag is "receive" semantics:
 * true  = user wants these emails (default)
 * false = user opted out (backend skips sending)
 */
export interface NotificationPreferences {
  attendanceReminders: boolean;
  absenceAlerts: boolean;
  leaveStatusEmails: boolean;
  leaveAdminAlerts: boolean;
}

interface ApiResult {
  success: boolean;
  data: NotificationPreferences | null;
  error: { message: string } | null;
}

/**
 * Get the current user's notification preferences.
 */
export const getNotificationPreferences = async (userId: string): Promise<ApiResult> => {
  try {
    const response = await httpClient.get(`/users/${userId}/notification-preferences`);
    return {
      success: true,
      data: response.preferences,
      error: null
    };
  } catch (error: any) {
    console.error('getNotificationPreferences error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

/**
 * Update the current user's notification preferences. Accepts a partial set;
 * only the provided flags are changed.
 */
export const updateNotificationPreferences = async (
  userId: string,
  preferences: Partial<NotificationPreferences>
): Promise<ApiResult> => {
  try {
    const response = await httpClient.put(
      `/users/${userId}/notification-preferences`,
      preferences
    );
    return {
      success: true,
      data: response.preferences,
      error: null
    };
  } catch (error: any) {
    console.error('updateNotificationPreferences error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};
